import React from "react";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import "./home.css";
import yourImage from "../assets/mexico.jpg"; // Cambia a la ruta de tu imagen
import letras from "../assets/letras/MEXICO.png"; // Cambia a la ruta de tu imagen
import imgperfil from "../assets/imgperfil.jpg"; // Cambia a la ruta de tu imagen
import Link from "@mui/material/Link";
import tenangoPattern from "../assets/tenango.png"; // Asegúrate de que esta ruta sea correcta

const generateStars = (count) => {
  const stars = [];
  for (let i = 0; i < count; i++) {
    stars.push(
      <Box
        key={i}
        sx={{
          content: '""',
          display: "block",
          width: "2px",
          height: "2px",
          backgroundColor: "white",
          borderRadius: "50%",
          position: "absolute",
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animation: `moveStar ${Math.random() * 20 + 10}s linear infinite`,
        }}
      />,
    );
  }
  return stars;
};

function Home() {
  return (
    <>
      {/* Imagen antes del Box */}
      <img
        src={letras}
        alt="Descripción de la imagen"
        style={{
          width: "100%", // Ajusta el ancho como desees
          height: "500px", // Mantiene la proporción
        }}
      />

      {/* Tarjeta en blanco centrada antes de las cards */}
      {/*   <Box sx={{ display: "flex", justifyContent: "center", paddingTop: 2 }}>
        <Card sx={{ maxWidth: 900, width: "100%", marginBottom: 2 }}>
          <CardActionArea>
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                <img
                  src={yourImage}
                  alt="Descripción de la imagen"
                  style={{
                    width: "100%",
                    height: "500px",
                  }}
                />
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box> */}

      {/* Contenedor del poema romántico y dramático */}
      {/*   <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: "40px",
          background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)", // Fondo dramático
          color: "#fff",
          fontFamily: "'Dancing Script', cursive", // Fuente romántica
          fontSize: "22px",
          fontStyle: "italic",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
          borderRadius: "15px",
          margin: "40px auto",
          maxWidth: "800px",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: "15px" }}
        >
          México en mi alma
        </Typography>
        <Typography>
          En tu suelo ardiente, mi México amado, donde el sol te besa con luz de
          oro, donde el viento canta en los campos dorados, y el amor florece en
          un laurel sonoro.
          <br />
          <br />
          Tus mares susurran secretos antiguos, en la luna llena de un cielo
          divino, tus montañas guardan historias eternas, entre el canto dulce
          de un viejo camino.
          <br />
          <br />
          México mío, con alma vibrante, con lágrimas, risas y sangre valiente,
          en cada bocado, en cada instante, eres mi amor, mi raíz, mi presente.
        </Typography>
      </Box> */}

      <Box
        sx={{
          "@keyframes moveStar": {
            "0%": {
              transform: "translateX(0) translateY(0)",
            },
            "100%": {
              transform: `translateX(${
                Math.random() * 500 - 250
              }px) translateY(${Math.random() * 500 - 250}px)`,
            },
          },
          position: "relative", // Necesario para posicionar las estrellas
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: "40px",
          background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
          color: "#fff",
          fontFamily: "'Dancing Script', cursive",
          fontSize: "22px",
          fontStyle: "italic",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
          borderRadius: "15px",
          margin: "40px auto",
          maxWidth: "800px",
          overflow: "hidden", // Para asegurarnos de que las estrellas no se salgan del contenedor
        }}
      >
        {/* Generamos muchas estrellas */}
        {generateStars(50)}
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: "15px" }}
        >
          México en mi alma
        </Typography>
        <Typography>
          En tu suelo ardiente, mi México amado, donde el sol te besa con luz de
          oro, donde el viento canta en los campos dorados, y el amor florece en
          un laurel sonoro.
          <br />
          <br />
          Tus mares susurran secretos antiguos, en la luna llena de un cielo
          divino, tus montañas guardan historias eternas, entre el canto dulce
          de un viejo camino.
          <br />
          <br />
          México mío, con alma vibrante, con lágrimas, risas y sangre valiente,
          en cada bocado, en cada instante, eres mi amor, mi raíz, mi presente.
        </Typography>
      </Box>

      <div className="container divbienvenida">
        {/* <header className="header">
          <h1 className="title">Bienvenido a BeyondTacos</h1>
          <p className="subtitle">Descubre la Auténtica Gastronomía Mexicana</p>
        </header> */}
        <div className="content">
          <p className="paragraph">
            En BeyondTacos, nos apasiona explorar y celebrar la rica diversidad
            culinaria de México, un país con una herencia gastronómica única y
            variada en cada uno de sus estados. Estamos aquí para romper
            fronteras y derribar mitos sobre la cocina mexicana, llevándote en
            un viaje sensorial a través de sus sabores, texturas y tradiciones
            culinarias.
          </p>
          <p className="paragraph">
            ¿Por qué BeyondTacos? Porque México es mucho más que tacos. Aunque
            amamos este emblemático platillo, reconocemos que la auténtica
            cocina mexicana va más allá de los estereotipos. Cada región tiene
            su propio repertorio de platos tradicionales, reflejando la
            diversidad cultural y la riqueza de ingredientes locales que hacen
            de la gastronomía mexicana un verdadero tesoro.
          </p>
          <p className="paragraph">
            En nuestra misión de promover el conocimiento y el respeto por la
            cocina mexicana, nos enfocamos en explorar los platos típicos de
            cada estado, desde los aromáticos moles de Oaxaca hasta los
            exquisitos mariscos de Baja California. Queremos desafiar el
            desconocimiento y el chovinismo que a veces separan a los mexicanos,
            creando un espacio donde todos puedan apreciar y aprender sobre las
            distintas tradiciones culinarias que enriquecen nuestra identidad
            nacional.
          </p>
          <p className="paragraph">
            Únete a nosotros en este viaje gastronómico mientras descubrimos los
            secretos mejor guardados de la cocina mexicana, compartamos recetas
            auténticas, destaquemos restaurantes locales y celebramos la
            diversidad que nos une como país.
          </p>
          <p className="paragraph">
            Bienvenido a BeyondTacos, donde cada bocado es un homenaje a la
            autenticidad, la diversidad y el amor por la comida mexicana.
          </p>
          <p className="paragraph">
            Nuestro objetivo fue organizar las comidas típicas de cada estado,
            en la investigación se profundizó en su origen y creación, aunque en
            casos específicos un plato puede compartir origen entre 2 o más
            estados, se tomó la decisión de ponerlo en ese estado en específico
            dado a su fama.
          </p>
          <p className="paragraph">¡Buen provecho!</p>
        </div>
      </div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center", // Centramos el contenido
          padding: 4, // Aumentamos el padding
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
          }}
        >
          {/* Imagen en círculo */}
          <Box
            sx={{
              width: 128, // Hacemos la imagen más grande
              height: 128, // Hacemos la imagen más grande
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #6b7280",
              marginBottom: 2, // Añadimos margen inferior
            }}
          >
            <img
              src={imgperfil}
              alt="Maximiliano Nuñez"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
          {/* Texto de presentación */}
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#1f2937" }}
            >
              Maximiliano Nuñez
            </Typography>
            <Typography variant="body1" sx={{ color: "#4b5563", marginTop: 2 }}>
              Soy Maximiliano, la gente me llama Max, un apasionado de la
              comida. Soy originario de la Ciudad de México y actualmente vivo
              en Lima, Perú. Desde niño me gustaba estar en la cocina, ayudando
              a mi mamá y mi abuela cuando vendían comida en México; desde
              entonces me enamoré de la gastronomía y de la cultura que la
              rodea. Estudié Ingeniería en Sistemas Computacionales en el
              Instituto Politécnico Nacional, en la Escuela Superior de Cómputo,
              y trabajé en el área de tecnología por varios años. Decidí ocupar
              mis conocimientos en tecnología para crear BeyondTacos, un espacio
              donde se pueda conocer la gastronomía mexicana. Por razones de la
              vida, conocí a Gaby, una chica peruana que visitaba CDMX; años
              después me casé con ella y me mudé a Perú. Aquí he tenido la
              oportunidad de aprender de la rica gastronomía peruana y tomé como
              inspiración la manera en que la gente de este país conoce de qué
              región es cada plato de su gastronomía, y decidí hacer lo mismo
              con la gastronomía mexicana. Me di cuenta de que la gente en
              México no sabe de qué estado es cada platillo; esto se debe al
              chovinismo que existe en el país. Las personas de una región no
              están familiarizadas con la gastronomía de otras, o simplemente no
              les interesa e incluso la desmerecen. Por eso decidí realizar este
              proyecto, para que la gente conozca la gastronomía de México, de
              qué estado es cada platillo, su origen y su creación, así como
              para dar a conocer fuera de México la diversidad de la gastronomía
              mexicana más allá de los tacos.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
        }}
      >
        <Box
          sx={{
            padding: 4,
            backgroundColor: "#7cd6d6",
            borderRadius: 1,
            boxShadow: 3,
            maxWidth: "800px",
            width: "40%",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            Mis Referencias
          </Typography>
          <Link
            href="https://docs.google.com/spreadsheets/d/1GnPiFEL1DCQA4kha06oJrVbK9Dbs7UY7_vS41kVpoYk/edit?pli=1&gid=2090500271#gid=2090500271"
            target="_blank"
            rel="noopener"
            sx={{ color: "#1e88e5", fontSize: "18px" }}
          >
            Ver mis referencias aquí
          </Link>
          <Link
            href="mailto:rogelio_max@hotmail.com"
            sx={{
              marginTop: 2,
              padding: 1,
              backgroundColor: "#1f2937",
              color: "white",
              borderRadius: 1,
              textDecoration: "none",
              display: "block", // Asegura que el enlace se muestre en una nueva línea
            }}
          >
            Comentarios, Aportes o Sugerencias
          </Link>
        </Box>
      </Box>

      {/* Reproductor de Spotify al final, con tamaño reducido y posicionado en la esquina inferior izquierda */}
      <iframe
        id="spotify-audio"
        src="https://open.spotify.com/embed/track/2sUknbm8xdLQgH7wb8xcTX"
        width="300"
        height="80"
        frameBorder="0"
        allow="encrypted-media; autoplay"
        title="Reproductor de Spotify"
        style={{
          position: "fixed",
          bottom: 20,
          left: 20,
          border: "none",
          zIndex: 1000,
        }}
      ></iframe>
    </>
  );
}

export default Home;
